/* ============================================================================
   EH 2BUY1FREE — redesigned always-on promo explainer
   ----------------------------------------------------------------------------
   Replaces the theme's image banner (#shopify-section-featured_background_image_tdkNxy)
   with a clear, premium 3-step explainer of the 2-buy-1-free offer:
   「お好きな商品を3点カートに追加すると、自動的に1点（最安値）が無料になります。」
   Additive / non-destructive: the original section is HIDDEN (display:none), not
   deleted — rollback = remove this file's include line. Brand base #385C60 + gold.
   Placement (2026-09-17 オーナー指示): 売れ筋ランキングの直上へ移動。
     カテゴリー直下はキャンペーンのポスター（STACK PACK等）に譲り、文字の多いバナーが
     2本続かないようにする。ランキングが無いページ構成では元の枠（旧バナーの位置）に戻る。
   ============================================================================ */
(function () {
  'use strict';
  if (window.__eh2b1f) return;
  window.__eh2b1f = true;

  if (!/(^|\s)template-index(\s|$)/.test(document.body ? document.body.className : '')) return;

  var BANNER_ID = 'shopify-section-featured_background_image_tdkNxy';
  var COLLECTIONS_ID = 'shopify-section-16639938608d00385a'; /* 正方形カテゴリー。eh-ranking.js はこの直後にランキングを入れる */
  var RULES_URL = '/pages/2buy1free%E3%81%A8%E3%81%AF'; /* = /pages/2buy1freeとは (HTTP 200) */

  var CSS = [
    '#eh-2buy1free{--b:#385C60;--bd:#16292b;--gd:#e9c987;--gd2:#c8a45c;position:relative;background:#fff;padding:6px 12px 26px;font-family:inherit;}',
    '.eh2b-wrap{max-width:1220px;margin:0 auto;}',
    '.eh2b-card{position:relative;overflow:hidden;border-radius:24px;padding:clamp(30px,5vw,58px) clamp(18px,5vw,60px);text-align:center;color:#fff;isolation:isolate;',
    'background:radial-gradient(120% 130% at 50% -12%,#3f6a6f 0%,#2c4a4d 40%,#16292b 100%);box-shadow:0 24px 54px -26px rgba(16,32,33,.7),inset 0 0 0 1px rgba(233,201,135,.14);}',
    '.eh2b-glow{position:absolute;inset:0;z-index:0;pointer-events:none;background:radial-gradient(50% 72% at 84% 10%,rgba(233,201,135,.24),transparent 60%),radial-gradient(48% 66% at 10% 98%,rgba(127,176,181,.22),transparent 62%);}',
    '.eh2b-inner{position:relative;z-index:1;}',
    '.eh2b-eyebrow{font-size:clamp(10px,1.4vw,12px);letter-spacing:.32em;font-weight:700;text-transform:uppercase;color:rgba(255,255,255,.72);margin:0 0 12px;}',
    '.eh2b-eyebrow i{font-style:normal;color:var(--gd);margin:0 .6em;}',
    '.eh2b-title{margin:0;font-size:clamp(27px,5.7vw,54px);font-weight:900;letter-spacing:.04em;line-height:1.16;color:#fff;}',
    '.eh2b-title b{font-weight:900;background:linear-gradient(180deg,#fff 0%,#fdf3d6 42%,#e9c987 78%,#d9b264 100%);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent;}',
    '.eh2b-lead{margin:12px auto 0;max-width:640px;font-size:clamp(13px,1.7vw,15px);line-height:1.85;color:rgba(230,240,240,.86);font-weight:500;}',
    '.eh2b-lead b{color:#fff;font-weight:800;}',
    '.eh2b-steps{display:flex;align-items:stretch;justify-content:center;gap:clamp(5px,1.3vw,15px);flex-wrap:nowrap;margin:clamp(26px,4vw,38px) auto clamp(4px,1.6vw,8px);max-width:780px;}',
    '.eh2b-step{flex:1 1 0;min-width:0;display:flex;flex-direction:column;align-items:center;gap:11px;padding:clamp(15px,2vw,22px) clamp(6px,1.2vw,14px);border-radius:16px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);}',
    '.eh2b-step--free{background:linear-gradient(180deg,rgba(233,201,135,.18),rgba(200,164,92,.07));border-color:rgba(233,201,135,.42);}',
    '.eh2b-num{width:38px;height:38px;flex:0 0 auto;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:900;font-style:italic;color:#16292b;background:linear-gradient(150deg,#fdf3d6,#e9c987 55%,#c8a45c);box-shadow:0 6px 14px -6px rgba(233,201,135,.7);}',
    '.eh2b-stxt{font-size:clamp(11px,1.5vw,13.5px);font-weight:600;line-height:1.5;color:rgba(255,255,255,.9);}',
    '.eh2b-stxt b{color:#fff;font-weight:900;}',
    '.eh2b-step--free .eh2b-stxt b{color:var(--gd);font-size:1.18em;}',
    '.eh2b-arrow{align-self:center;flex:0 0 auto;font-size:clamp(15px,2vw,22px);color:rgba(233,201,135,.72);font-weight:400;}',
    '.eh2b-cta{display:inline-flex;align-items:center;gap:.5em;margin-top:clamp(20px,3vw,28px);font-size:clamp(13px,1.7vw,15px);font-weight:800;letter-spacing:.04em;text-decoration:none;color:#fff;padding:.8em 1.7em;border-radius:999px;border:1.5px solid rgba(233,201,135,.5);background:rgba(255,255,255,.04);transition:background .25s ease,border-color .25s ease,transform .25s ease,color .25s ease;}',
    '.eh2b-cta span{transition:transform .25s ease;}',
    '.eh2b-cta:hover{background:linear-gradient(180deg,#fdf3d6,#e2b866);border-color:transparent;color:#22383a;transform:translateY(-2px);}',
    '.eh2b-cta:hover span{transform:translateX(4px);}',
    '@media(max-width:600px){.eh2b-steps{gap:5px;}.eh2b-step{padding:13px 5px;gap:8px;border-radius:13px;}.eh2b-num{width:31px;height:31px;font-size:15px;}.eh2b-arrow{font-size:14px;}}'
  ].join('\n');

  function build() {
    var sec = document.createElement('section');
    sec.id = 'eh-2buy1free';
    sec.setAttribute('aria-label', '2点購入で1点無料');
    sec.innerHTML =
      '<div class="eh2b-wrap">' +
        '<div class="eh2b-card">' +
          '<span class="eh2b-glow" aria-hidden="true"></span>' +
          '<div class="eh2b-inner">' +
            '<div class="eh2b-eyebrow">EMPIRE HOLLYWOOD<i>✦</i>ALWAYS ON</div>' +
            '<h2 class="eh2b-title">2点購入で、<b>1点無料</b></h2>' +
            '<p class="eh2b-lead">お好きな商品を<b>3点</b>カートに追加すると、自動的に<b>1点（最安値）</b>が<b>無料</b>になります。</p>' +
            '<div class="eh2b-steps">' +
              '<div class="eh2b-step"><span class="eh2b-num">1</span><span class="eh2b-stxt">お好きな商品を<br><b>3点</b>えらぶ</span></div>' +
              '<span class="eh2b-arrow" aria-hidden="true">&#8594;</span>' +
              '<div class="eh2b-step"><span class="eh2b-num">2</span><span class="eh2b-stxt">カートに<br><b>追加する</b></span></div>' +
              '<span class="eh2b-arrow" aria-hidden="true">&#8594;</span>' +
              '<div class="eh2b-step eh2b-step--free"><span class="eh2b-num">3</span><span class="eh2b-stxt">1点（最安値）が<br><b>自動で ¥0</b></span></div>' +
            '</div>' +
            '<a class="eh2b-cta" href="' + RULES_URL + '">ルールを詳しく見る <span>&#8594;</span></a>' +
          '</div>' +
        '</div>' +
      '</div>';
    return sec;
  }

  function run() {
    if (document.getElementById('eh-2buy1free')) return;
    var style = document.createElement('style');
    style.id = 'eh-2buy1free-css';
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);

    var node = build();
    var waited = 0, total = 0;
    function attempt() {
      total++;
      var banner = document.getElementById(BANNER_ID);
      if (banner) banner.style.display = 'none';
      // ① 売れ筋ランキングの直上
      var rank = document.querySelector('[data-eh-rank-wrap]');
      if (rank && rank.parentNode) { rank.parentNode.insertBefore(node, rank); return true; }
      // ② ランキングはカテゴリー直後に DOMContentLoaded で入る。少しだけ待つ（最大約1秒）
      var cols = document.getElementById(COLLECTIONS_ID);
      if (cols && waited < 8) { waited++; return false; }
      if (cols && cols.parentNode) { cols.insertAdjacentElement('afterend', node); return true; }
      // ③ ランキングもカテゴリーも無い構成：旧バナーの枠へ
      if (banner && banner.parentNode) { banner.parentNode.insertBefore(node, banner); return true; }
      return total > 40;
    }
    if (attempt()) return;
    var iv = setInterval(function () { if (attempt()) clearInterval(iv); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
